<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable max-width="70%">
      <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="submit">
        <v-card>
          <v-card-title class="primary white--text"> <v-icon color="white" class="mx-2">mdi-whatsapp</v-icon> Enviar mensaje por WhatsApp </v-card-title>
          <v-card-text class="pa-4" v-if="persona">
            <v-textarea outlined v-model="mensaje" :counter="1900" dense :rules="smsRules" label="Mensaje" :hint="showHint(phone)"></v-textarea>
            <p class="pa-2 font-weight-bold mb-0 pb-0">Al enviar se abrirá una ventana nueva en donde se transcribira el mensaje a enviar</p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="submit" color="success" rounded class="px-2"> Enviar <v-icon class="ml-1"> mdi-send</v-icon> </v-btn>
            <v-btn color="blue darken-1" outlined rounded @click="closeDialog"> Cancelar <v-icon> mdi-close</v-icon> </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  data() {
    return {
      smsRules: [(v) => !!v || 'Se requiere un mensaje', (v) => (v && v.length <= 1900) || 'Superó el limite del mensaje'],
      valid: true,
      persona: null,
      phone: null,
      mensaje: null,
      dialog: false,
    };
  },
  methods: {
    showThisView(persona, telefono, mensaje) {
      this.persona = persona;
      this.phone = telefono;
      this.mensaje = mensaje;
      this.dialog = true;
    },
    showHint(numero) {
      return `el contenido de este campo será enviado al whatsapp : ${numero}`;
    },
    submit() {
      if (this.$refs.form.validate()) {
        window.open(`${process.env.VUE_APP_API_WHATSAPP}` + this.phone + '&text=' + this.mensaje);
      }
    },
    closeDialog() {
      this.persona = null;
      this.phone = null;
      this.mensaje = null;
      this.dialog = false;
    },
  },
};
</script>